import { render } from "./OrgLovComponent.vue?vue&type=template&id=6879d09a"
import script from "./OrgLovComponent.vue?vue&type=script&lang=js"
export * from "./OrgLovComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__